import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { BillingItem } from "../types";

export type BillStatsData = Pick<BillingItem, "id_bill" | "status_bill">;

export const fetchBillsStats = async (): Promise<ApiResponse<BillStatsData[]>> => {
  return await apiClient<ApiResponse<BillStatsData[]>>('/v1/bills/stats');
};
